import React, { FC } from 'react';
import SectionTitle from '@src/components/SectionTitle';
import { PositionLocationDropdownItem } from '@src/components/PositionLocationDropdown/interfaces/positionLocationDropdownItem.interface';
import { OpeningQueryQuery } from '@src/graphql/generated';
import { MultipleLocations } from '../MultipleLocations';
import './styles.scss';

export interface PositionLocationProps {
  onLocationSelected: (locations: PositionLocationDropdownItem[]) => void;
  opening: OpeningQueryQuery['opening'];
}

export const PositionLocation: FC<PositionLocationProps> = ({ onLocationSelected, opening }) => {
  return (
    <div className="position-location">
      <SectionTitle
        className="position-location__section-title"
        size="M"
        subtitle="In which city is this position located"
        title="Position location"
      />

      <MultipleLocations
        defaultLocations={opening.positionLocations || []}
        limit={3}
        onLocationSelected={onLocationSelected}
      />
    </div>
  );
};
